import { render } from "./comp.navigationSecondaire.vue?vue&type=template&id=8cd94a78"
import script from "./comp.navigationSecondaire.vue?vue&type=script&lang=js"
export * from "./comp.navigationSecondaire.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__